import React from 'react';
import { withRouter, NavLink } from 'react-router-dom';

// Just like NavLink, but returns <span> instead of <a> if active
// linkClassName will be appended to className if <a> is rendered
const NavLinkSpan = props => {
  const {
    children,
    history,
    to,
    staticContext,
    className,
    linkClassName,
    ...rest
  } = props;
  return (
    <React.Fragment>
      {history.location.pathname === to ? (
        <span {...{ className, ...rest }}>{children}</span>
      ) : (
        <NavLink
          className={`${className} ${linkClassName}`}
          {...{ to, ...rest }}
        >
          {children}
        </NavLink>
      )}
    </React.Fragment>
  );
};

export default withRouter(NavLinkSpan);



// WEBPACK FOOTER //
// ./src/modules/misc/components/NavLinkSpan.js